const CustomSPObras = () => import('@/views/custom/consorciolmm/ConsorcioLmmSPObras')
const CustomSPObrasForm = () => import('@/views/custom/consorciolmm/ConsorcioLmmSPObrasForm')
const CustomChecklistReport = () => import('@/views/custom/consorciolmm/ConsorcioLmmChecklistReport')

export default {
    remove: [
        "checklist-report",
    ],
    routes: [
        {
            path: '/custom/checklist/spobras/view/:id',
            name: 'custom-consorciolmm-checklist-spobras-form-view',
            component: CustomSPObrasForm
        }, {
            path: '/custom/checklist/spobras/:id',
            name: 'custom-consorciolmm-checklist-spobras-form',
            component: CustomSPObrasForm
        },
        {
            path: '/custom/checklist/spobras',
            name: 'custom-consorciolmm-checklist-spobras',
            component: CustomSPObras
        },
        {path: '/custom/checklist/report', name: 'custom-consorciolmm-checklist-report', component: CustomChecklistReport},

    ]
}
